import React, { useState, useEffect, useRef } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import logo from "../images/logo.png";
import arrow from "../images/arrow.png";
import dashboard from "../images/dashboard.png";
import job from "../images/Work.png";
import user_settings from "../images/user.png";
import gear from "../images/gear.png";
import Homepage from "../components/Homepage";
import Jobs from "../components/Jobs";
import Board from "../components/Board";
import Candidate from "../components/Candidates";
import All from "../components/All";
import Interview from "../components/Interview";
import Intervieews from "../components/Intervieews";
import logobrand from "../images/logobrand.png";
import User from "../components/User";
import Help from "../components/Help";
import Roles from "../components/Roles";
import { useSelector, useDispatch } from "react-redux";
import {
  companyIdSlice,
  updateCompanyId,
  selectCid,
} from "../features/companyid";
import Management from "../components/Management";
import Profile from "../components/Profile";
import logout from "../images/Logout.png";
import { faqs } from "../components/Faqs";
import NewJobs from "./NewJobs";
import { FiSearch } from "react-icons/fi";
// import markerSDK from '@marker.io/browser';

import NewUser from "./NewUser";
import dashboard_white from "../images/dashboard_white.png";
import job_white from "../images/Work_white.png";
import user_white from "../images/user_white.png";
import help from "../images/faq.png";
import { server_API } from "../config";
import gear_white from "../images/gear_white.png";
import sec_help from "../images/help.png";
import { ToastIcon } from "../components/TestOfferInitiation";
import NewCandidate from "./NewCandidate";
import profile from "../images/Profile.png";
import Templates from "../components/Templates";
import axios from "axios";
import { Chart as ChartJS, ArcElement, Tooltip, Legend } from "chart.js";
import { CiMenuFries, CiSettings } from "react-icons/ci";
import {
  updateUserId,
  updatePrivilege,
  getUserPrivilege,
  getSpecialTab,
  updateSpecialTab,
  updateUserName,
  updateUserEmail,
  getUserInternalSource,
  updateInternalSource,
} from "../features/userid";
import pp from "../images/pp.png";
import { HiOutlineTemplate } from "react-icons/hi";
import Draggable, { DraggableCore } from "react-draggable";
import AboutCandidate from "../components/AboutCandidate";
import BulkUpload from "../components/BulkUpload";
import TestAboutCandidate from "../components/TestAboutCandidate";
import { selectUuid, userId } from "../features/userid";
import DocumentReq from "./DocumentReq";
import SalaryProposal from "./SalaryProposal";
import Dashboard from "./Dashboard/Dashboard";
import rightarrow from "../images/right arrow.png";
import TempCandidates from "../components/TempCandidates";
import TestOfferInitiation from "../components/TestOfferInitiation";
import Copyright from "../components/Copyright";
import axiosInstance, { removeAccessToken } from "../axiosInstance";
import HackerRankCandidate from "../components/HackerRankCandidate";
import CoderbyteCandidate from "../components/CoderbyteCandidate";
import { REDIRECTION_LINKS, roleTypes } from "../constants/common";
import {
  formatNotificationDate,
  formatTime,
  getUserTimezone,
} from "../utils/dateUtils";
import InterviewCredit from "./InterviewCredit";
import { FaChartLine, FaUsers } from "react-icons/fa";
import OutreachedJobs from "../components/OutreachedJobs";
import OutreachedCandidates from "../components/OutreachedCandidates";
import TalentPool from "../components/TalentPool";

ChartJS.register(ArcElement, Tooltip, Legend);
const Home = () => {
  const location = useLocation();
  const uuid = useSelector(selectUuid);
  const [im1, setIm1] = useState(dashboard_white);
  const [im2, setIm2] = useState(job);
  const [im3, setIm3] = useState(user_settings);
  const [im4, setIm4] = useState(gear);
  const [im5, setIm5] = useState(<FaUsers className="h-6 w-6" />);
  const [visible, setVisible] = useState(false);
  const [companyStatus, setCompanyStatus] = useState();
  const [reviewOpen, setReviewOpen] = useState("");
  const [logo, setLogo] = useState("");
  const [right, setRights] = useState("");
  const [name, setName] = useState("");
  const [search, setSearch] = useState("");
  const [interviews, setInterviews] = useState([]);
  const navigate = useNavigate();
  const [companyUuid, setCompanyUuid] = useState("");
  const [jobs, setJobs] = useState([]);
  const [applicants, setApplicants] = useState([]);
  const [openNotifications, setOpenNotifications] = useState(false);
  const [openPopup, setOpenPopup] = useState("");
  const [nameReview, setNameReview] = useState("");
  const [reviewDescription, setReviewDescription] = useState("");
  const [reviewSaved, setReviewSaved] = useState(false);
  const [notifications, setNotifications] = useState([]);
  const [jidToNameMap, setJidToNameMap] = useState(new Map());
  const [notificationTimezone] = useState(() => getUserTimezone());
  const cid = useSelector(selectCid);
  const dispatch = useDispatch();
  const userPrivilege = useSelector(getUserPrivilege);
  const specialTab = useSelector(getSpecialTab);
  const internalSource = useSelector(getUserInternalSource);

  const isHiringManager = userPrivilege === roleTypes.hiringManager;

  const ref = useRef();

  const rec = [
    {
      key: "dashboard",
      name: "Dashboard",
      info: "Navigate to dashboard",
    },
    {
      key: "jobs",
      name: "Listed Jobs",
      info: "Navigate to listed jobs",
    },
    {
      key: "new job",
      name: "New job",
      info: "List a new job",
    },
    {
      key: "users",
      name: "Users",
      info: "Navigate to listed users",
    },
    {
      key: "new user",
      name: "New User",
      info: "Add a new user",
    },
  ];

  function useOnClickOutside(ref, handler) {
    useEffect(() => {
      const listener = (event) => {
        // Do nothing if clicking ref's element or descendent elements
        if (!ref.current || ref.current.contains(event.target)) {
          return;
        }
        handler(event);
      };
      document.addEventListener("mousedown", listener);
      document.addEventListener("touchstart", listener);
      return () => {
        document.removeEventListener("mousedown", listener);
        document.removeEventListener("touchstart", listener);
      };
    }, [ref, handler]);
  }

  useEffect(() => {
    axiosInstance
      .get(`/v2/notification/getusernotification/${cid}`, {
        withCredentials: true,
      })
      .then((res) => {
        setNotifications(res.data);
      })
      .catch((err) => {
        console.log(err);
      });

    axiosInstance
      .get(`/v2/user/getuser`, {
        withCredentials: true,
      })
      .then((res) => {
        console.log(res);
        dispatch(updateUserId(res.data.success.uuid));
        dispatch(updatePrivilege(res.data.success.privilege));
        dispatch(updateUserName(res.data.success.name));
        dispatch(updateUserEmail(res.data.success.email));
      })
      .catch((err) => {
        console.log(err);
      });
  }, []);

  const handleNotificationClick = (notification) => {
    if (notification.notificationtype == "") return;
    const data = JSON.parse(notification.subtask);
    if (notification.notificationtype == "Interview") {
      navigate("/jobs/candidates/about", { state: { uuid: data.id } });
      setOpenNotifications(false);
    } else if (notification.notificationtype == "Approval") {
      navigate("/jobs/candidates/about", {
        state: { uuid: data.id, proposalId: data.docid },
      });
    }
  };

  const saveReview = () => {
    axios
      .post(`${server_API}/v2/feedback/create`, {
        name: nameReview,
        description: reviewDescription,
      })
      .then((response) => {
        console.log(response);
        setReviewSaved(true);
      })
      .catch((error) => {
        console.log(error);
      });
  };

  const handleSearch = (key, cat) => {
    setSearch("");
    if (cat == "tab") {
      if (key == "dashboard") {
        navigate("/home");
      } else if (key == "jobs") {
        navigate("/jobs");
      } else if (key == "new job") {
        navigate("/jobs/new");
      } else if (key == "users") {
        navigate("/user");
      } else if (key == "new user") {
        navigate("/user/new");
      } else if (key == "talent pool") {
        navigate("/talent-pool");
      }
    } else if (cat == "job") {
      navigate("/jobs/candidates/temp", { state: { id: key } });
    }
  };

  // const uuid = localStorage.getItem('uuid')

  useEffect(() => {
    window.scrollTo(0, 0);
    axiosInstance
      .get(`/v2/user/getuser`)
      .then((res) => {
        console.log(res);
        setRights(res.data.success.privilege);
        setName(res.data.success.name);
        setCompanyUuid(res.data.success.companyid);
        dispatch(updateCompanyId(res.data.success.companyid));

        axios
          .get(`${server_API}/v2/company/get/${res.data.success.companyid}`)
          .then((response) => {
            console.log(response);
            if (response.data.companystatus !== undefined) {
              setCompanyStatus(response.data.companystatus);
              dispatch(updateSpecialTab(res.data.success.sourcing || false));
              dispatch(updateInternalSource(res.data.success.internal_source || false));
            } else {
              setCompanyStatus(true);
            }
          })
          .catch((error) => {
            console.log(error);
          });
      })
      .catch((err) => {
        console.log(err);
      });
  }, []);

  useEffect(() => {
    if (jobs.length > 0) {
      var m = new Map();
      jobs.map((j) => {
        m.set(j.uuid, j.profilename);
      });
      setJidToNameMap(m);
    }
  }, [jobs]);

  useEffect(() => {
    if (companyUuid.length > 0) {
      axios
        .get(`${server_API}/v2/company/geturl/${companyUuid}`)
        .then((response) => {
          console.log(response);
          setLogo(response.data.url);
          //   console.log(response.data.url)
        })
        .catch((err) => {
          console.log(err);
        });

      axios
        .get(`${server_API}/v2/interview/company/${companyUuid}`)
        .then((res) => {
          console.log(res);
          setInterviews(res.data);
        })
        .catch((err) => {
          console.log(err);
          setInterviews([]);
        });

      axios
        .get(`${server_API}/v2/job/getjobs/${companyUuid}`)
        .then((res) => {
          if (res.data) {
            setJobs(res.data);
          } else {
            setJobs([]);
          }
        })
        .catch(() => setJobs([]));
      axios
        .get(`${server_API}/v2/applicant/search-list/${companyUuid}`)
        .then((res) => setApplicants(Array.isArray(res.data) ? res.data : []))
        .catch(() => setApplicants([]));
    }
  }, [companyUuid]);

  useOnClickOutside(ref, () => setOpenPopup(false));

  useEffect(() => {
    if (location.pathname === "/home") {
      setIm1(dashboard_white);
      setIm2(job);
      setIm3(user_settings);
      setIm4(gear);
      setIm5(<FaUsers className="h-6 w-6" />);
    } else if (location.pathname === "/jobs") {
      setIm1(dashboard);
      setIm2(job_white);
      setIm3(user_settings);
      setIm4(gear);
      setIm5(<FaUsers className="h-6 w-6" />);
    } else if (location.pathname === "/user") {
      setIm1(dashboard);
      setIm2(job_white);
      setIm3(user_white);
      setIm4(gear);
      setIm5(<FaUsers className="h-6 w-6" />);
    } else if (location.pathname.includes("settings")) {
      setIm1(dashboard);
      setIm2(job_white);
      setIm3(user_white);
      setIm4(gear_white);
      setIm5(<FaUsers />);
    } else if (location.pathname === REDIRECTION_LINKS.talentPool) {
      setIm1(dashboard);
      setIm2(job_white);
      setIm3(user_white);
      setIm4(gear_white);
      setIm5(<FaUsers className="stroke-white text-white h-6 w-6" />);
    }
  }, [location.pathname]);

  return (
    <div className="relative bg-[#f0f4fc]">
      {!reviewOpen && (
        <Draggable className="w-full " bounds={{ top: 0, bottom: 0 }}>
          <div className="fixed bottom-0 right-5 bg-red-500 text-white py-3 px-5 rounded-t-lg z-50">
            <button
              onClick={() => {
                setReviewOpen(true);
              }}
            >
              Feedback
            </button>
          </div>
        </Draggable>
      )}

      {reviewOpen && (
        <div className="fixed bottom-0 right-5 shadow-xl border w-[20rem] text-white rounded-t-lg z-50">
          <div className="bg-slate-500 text-center rounded-t-lg relative py-2">
            <p>Feedback</p>
            <button
              onClick={() => {
                setReviewOpen(false);
                setReviewSaved(false);
              }}
              className="absolute left-0 p-2 top-0"
            >
              X
            </button>
          </div>
          {!reviewSaved ? (
            <div className="bg-white text-black px-3 py-2">
              <div>
                <p className="my-1">Your name:</p>
                <input
                  onChange={(e) => {
                    setNameReview(e.target.value);
                  }}
                  className="outline-none px-2 py-2 w-full rounded-lg border"
                ></input>
              </div>
              <div>
                <p className="my-1 mt-3">
                  Description of the problem you faced:
                </p>
                <textarea
                  onChange={(e) => {
                    setReviewDescription(e.target.value);
                  }}
                  rows="6"
                  className="outline-none px-2 py-2 w-full rounded-lg border"
                ></textarea>
              </div>
              <button
                className="my-3 border w-full rounded-xl text-white py-3 bg-red-500 "
                onClick={() => {
                  saveReview();
                }}
              >
                Save
              </button>
            </div>
          ) : (
            <div className="bg-white text-black px-3 py-2">
              <p className="my-20 text-center">
                Thank you! Your feedback is valuable to us.
              </p>
            </div>
          )}
        </div>
      )}

      <div className="flex sticky z-50 top-0 w-full items-center shadow-xl justify-between py-[20px] px-6 font-semibold text-xl bg-white">
        <div className="flex space-x-12 w-1/2  items-center">
          <img
            className="h-12 aspect-[5/3] object-contain"
            src={logo}
            alt=""
          ></img>
          <p>Hi {name.split(" ")[0]}</p>
        </div>

        {/* <button onClick={()=>{
                navigate('/')
                localStorage.clear()
            }}> */}
        {/* <IoIosLogOut className="text-2xl"></IoIosLogOut> */}
        <div className="relative w-full items-center justify-end flex gap-4">
          <div className=" relative">
            <div className="bg-[#F1F4FB] flex justify-center gap-2 items-center p-4 py-3 rounded-[8px] h-[46px]">
              {" "}
              <input
                value={search}
                onChange={(e) => {
                  setSearch(e.target.value);
                }}
                className=" text-sm bg-[#F1F4FB] font-normal p-1 h-6  outline-none "
                placeholder="Search..."
              ></input>
              <FiSearch className="text-[#444D63] w-6 h-6"></FiSearch>
            </div>

            {search.length > 0 && (
              <div className="absolute font-normal border-x border-b rounded-xl max-h-[20rem] overflow-y-scroll z-50 bg-white p-4 w-full">
                {rec.map((r, i) => {
                  if (r.key.includes(search.toLowerCase())) {
                    return (
                      <button
                        onClick={() => {
                          handleSearch(r.key, "tab");
                        }}
                        className="py-2 w-full hover:bg-gray-100 rounded-lg p-2 text-left border-b"
                      >
                        <p className="text-base font-semibold">{r.name}</p>
                        <p className="text-sm">{r.info}</p>
                      </button>
                    );
                  }
                })}
                {applicants.map((a) => {
                  if (a.name.toLowerCase().includes(search.toLowerCase())) {
                    return (
                      <button
                        onClick={() => {
                          setSearch("");
                          navigate("/jobs/candidates/about", {
                            state: { uuid: a.uuid, id: a.jobid },
                          });
                        }}
                        className="py-2 hover:bg-gray-100 rounded-lg p-2 w-full text-left border-b"
                      >
                        <p className="text-base font-semibold">{a.name}</p>
                        <p className="text-sm">{jidToNameMap.get(a.jobid)}</p>
                      </button>
                    );
                  }
                })}
                {jobs.map((j) => {
                  if (
                    j.profilename.toLowerCase().includes(search.toLowerCase())
                  ) {
                    return (
                      <button
                        onClick={() => {
                          handleSearch(j.uuid, "job");
                        }}
                        className="py-2 hover:bg-gray-100 rounded-lg p-2 w-full text-left border-b"
                      >
                        <p className="text-base font-semibold">
                          {j.profilename}
                        </p>
                        <p className="text-sm">Listed Job</p>
                      </button>
                    );
                  }
                })}
                {faqs.map((f) => {
                  if (f.question.toLowerCase().includes(search.toLowerCase())) {
                    return (
                      <button
                        onClick={() => {
                          setSearch("");
                          navigate("/help");
                        }}
                        className="py-2 hover:bg-gray-100 rounded-lg p-2 w-full text-left border-b"
                      >
                        <p className="text-base font-semibold">{f.question}</p>
                        <p className="text-sm">FAQ</p>
                      </button>
                    );
                  }
                })}
              </div>
            )}
          </div>
          <div
            onClick={() => {
              setOpenNotifications(!openNotifications);
            }}
            className="bg-[#F1F4FB] cursor-pointer flex justify-center gap-1 items-center p-[11px] rounded-[8px]"
          >
            <NotificationIconWithBadge count={notifications.length} />
          </div>
          {/* <Link to="/help">
                    <img src={help} className=" h-12 p-2 border rounded-xl"></img>
                    </Link> */}
          <img
            src={pp}
            onClick={() => {
              setOpenPopup(!openPopup);
            }}
            className="h-[46px] bg-[#F1F4FB]  cursor-pointer rounded-[8px]"
          ></img>
          {openPopup && (
            <div
              ref={ref}
              className="absolute z-30 top-9 flex flex-col mt-2 space-y-3 right-0 w-40 bg-white rounded-xl p-4 border"
            >
              <Link to="/settings/profiles">
                <button
                  className="h-full"
                  onClick={() => {
                    setOpenPopup(false);
                  }}
                >
                  <div className="flex space-x-3 items-center ">
                    <img className="h-4 " src={profile}></img>
                    <p className="text-sm font-normal">Profile</p>
                  </div>
                </button>
              </Link>
              <button
                className="h-full"
                onClick={() => {
                  setOpenPopup(false);
                  navigate("/settings");
                }}
              >
                <div className="flex  space-x-3 items-center ">
                  <HiOutlineTemplate className="text-sm"></HiOutlineTemplate>
                  <p className="text-sm font-normal">Templates</p>
                </div>
              </button>
              {/* <Link to="/settings">
                    </Link> */}
              <button
                onClick={() => {
                  removeAccessToken();
                }}
              >
                <div className="flex space-x-3 items-center ">
                  <img className="h-4" src={logout}></img>
                  <p className="text-sm font-normal text-[#F7284A]">Logout</p>
                </div>
              </button>
            </div>
          )}
        </div>

        {/* </button> */}
      </div>
      <div className="flex w-full h-full min-h-screen">
        {/* side bar */}
        <div className="w-[7rem] hidden md:block  px-2 bg-[#1D2A3D]">
          <div className="py-5 sticky top-20 ">
            <div className="flex flex-col list-disc space-y-4 my-4">
              <Link to="/home">
                <div
                  className={
                    window.location.href.includes("home")
                      ? "flex bg-[#148EFF] py-3  w-full rounded-xl text-white items-center justify-between"
                      : "flex text-[#AAB3CC] py-3  w-full rounded-xl items-center justify-between"
                  }
                >
                  <div className="mx-auto">
                    <img className="h-6 mx-auto" src={im1}></img>
                    <p className="text-center text-sm mt-2">Dashboard</p>
                  </div>
                </div>
              </Link>

              <Link to="/jobs">
                <div
                  className={
                    window.location.href.includes("jobs")
                      ? "flex text-white bg-[#148EFF] py-3 px-3 w-full rounded-xl items-center justify-between"
                      : "flex text-[#AAB3CC] py-3 px-3 w-full rounded-xl items-center justify-between"
                  }
                >
                  <div className="mx-auto">
                    <img className="h-6 mx-auto" src={im2}></img>
                    <p className=" text-sm text-center mt-2">Job</p>
                  </div>
                </div>
              </Link>

              {right == "Admin" && (
                <Link to="/user" state={{ companyStatus: companyStatus }}>
                  <div
                    className={
                      window.location.href.includes("user")
                        ? "flex text-white bg-[#148EFF] py-3  w-full rounded-xl items-center justify-between"
                        : "flex text-[#AAB3CC] py-3 w-full rounded-xl items-center justify-between"
                    }
                  >
                    <div className="mx-auto">
                      <img className="h-6 mx-auto" src={im3}></img>
                      <p className=" text-sm text-center mt-2">Users</p>
                    </div>
                  </div>
                </Link>
              )}

              {!isHiringManager && (
                <Link to="/outreach" className="relative">
                  <div
                    className={
                      window.location.href.includes(REDIRECTION_LINKS.outreach)
                        ? "flex text-white bg-[#148EFF] py-3 px-3 w-full rounded-xl items-center justify-between"
                        : "flex text-[#AAB3CC] py-3 px-3 w-full rounded-xl items-center justify-between"
                    }
                  >
                    <div className="mx-auto">
                      <FaChartLine className="h-6 mx-auto"></FaChartLine>
                      <p className=" text-sm text-center mt-2 relative">
                        Outreach
                      </p>
                    </div>
                  </div>
                </Link>
              )}

              {internalSource && <Link to={REDIRECTION_LINKS.talentPool}>
                <div
                  className={
                    window.location.href.includes(REDIRECTION_LINKS.talentPool)
                      ? "flex text-white bg-[#148EFF] py-3 px-3 w-full rounded-xl items-center justify-between relative"
                      : "flex text-[#AAB3CC] py-3 px-3 w-full rounded-xl items-center justify-between relative"
                  }
                >
                  <div className="mx-auto">
                    <div className="mx-auto w-fit">
                      {im5}
                    </div>
                    <p className=" text-sm text-center mt-2">Scout</p>
                    <span className="absolute top-1.5 -right-1.5 italic text-black px-3 py-0 text-xs rounded-2xl">
                      Beta
                    </span>
                  </div>
                </div>
              </Link>}

              <Link to="/help">
                <div
                  className={
                    window.location.href.includes("help")
                      ? "flex text-white bg-[#148EFF] py-3 px-3 w-full rounded-xl items-center justify-between"
                      : "flex text-[#AAB3CC] py-3 px-3 w-full rounded-xl items-center justify-between"
                  }
                >
                  <div className="mx-auto">
                    <img className="h-6 mx-auto" src={sec_help}></img>
                    <p className=" text-sm text-center mt-2">Help</p>
                  </div>
                </div>
              </Link>

              {/* <Link to="/settings">
                    <div className={window.location.href.includes('settings')?"flex text-white bg-[#148EFF] py-3 px-3 w-full rounded-xl items-center justify-between":"flex text-[#AAB3CC] py-3 px-3 w-full rounded-xl items-center justify-between"}>
                    <div className="mx-auto">
                    <img className="h-6 mx-auto" src={im4}></img>
                    <p className=" text-sm text-center mt-2">Settings</p>
                    </div>
                </div>
                </Link> */}


            </div>
          </div>
        </div>

        <div className="flex w-full flex-col h-full min-h-screen">
          {visible && (
            <div className="w-2/3 absolute h-full z-40 min-h-screen bg-[#1D2A3D] right-0 backdrop-blur-[20px] backdrop-filter ">
              <div className="py-5 px-5 h-full  w-full">
                <div className="flex flex-col w-full  h-full  space-y-6 my-10">
                  <Link to="/home">
                    <div
                      className={
                        window.location.href.includes("home")
                          ? "flex  bg-[#148EFF] py-3 px-3 w-full rounded-xl text-white items-center justify-between"
                          : "flex text-[#AAB3CC] py-3 px-3 w-full rounded-xl items-center justify-between"
                      }
                    >
                      <div className="flex space-x-3">
                        <img className="h-6" src={im1}></img>
                        <p className=" text-md">Dashboard</p>
                      </div>
                    </div>
                  </Link>

                  <Link to="/jobs">
                    <div
                      className={
                        window.location.href.includes("jobs")
                          ? "flex text-white bg-[#148EFF] py-3 px-3 w-full rounded-xl items-center justify-between"
                          : "flex text-[#AAB3CC] py-3 px-3 w-full rounded-xl items-center justify-between"
                      }
                    >
                      <div className="flex space-x-3">
                        <img className="h-6" src={im2}></img>
                        <p className=" text-md">Job</p>
                      </div>
                    </div>
                  </Link>

                  {right && (
                    <Link to="/user">
                      <div
                        className={
                          window.location.href.includes("user")
                            ? "flex text-white bg-[#148EFF] py-3 px-3 w-full rounded-xl items-center justify-between"
                            : "flex text-[#AAB3CC] py-3 px-3 w-full rounded-xl items-center justify-between"
                        }
                      >
                        <div className="flex space-x-3">
                          <img className="h-6" src={im3}></img>
                          <p className=" text-md">User Management</p>
                        </div>
                      </div>
                    </Link>
                  )}

                  <Link to="/settings">
                    <div
                      className={
                        window.location.href.includes("settings")
                          ? "flex text-white bg-[#148EFF] py-3 px-3 w-full rounded-xl items-center justify-between"
                          : "flex text-[#AAB3CC] py-3 px-3 w-full rounded-xl items-center justify-between"
                      }
                    >
                      <div className="flex space-x-3">
                        <img className="h-6" src={im4}></img>
                        <p className=" text-md">Settings</p>
                      </div>
                      <img className="h-2" src={arrow}></img>
                    </div>
                  </Link>
                  {window.location.href.includes("settings") && (
                    <div className="flex flex-col text-white ml-6 my-4 space-y-3 list-disc">
                      <Link to="/settings">
                        <li
                          className={
                            window.location.hash == "#/settings"
                              ? "text-[#148EFF]"
                              : "text-[#AAB3CC]"
                          }
                        >
                          Templates
                        </li>
                      </Link>
                      <Link to="/settings/profiles">
                        <li
                          className={
                            window.location.hash == "#/settings/profiles"
                              ? "text-[#148EFF]"
                              : "text-[#AAB3CC]"
                          }
                        >
                          Profiles
                        </li>
                      </Link>
                      {/* <Link to="/settings/boards">
                        <li className={window.location.hash =="#/settings/boards"?"text-[#148EFF]":"text-[#AAB3CC]"}>Job Boards</li>
                    </Link> */}
                    </div>
                  )}

                  {!isHiringManager && (
                    <Link to={REDIRECTION_LINKS.outreach}>
                      <div
                        className={
                          window.location.href.includes(
                            REDIRECTION_LINKS.outreach,
                          )
                            ? "flex text-white bg-[#148EFF] py-3 px-3 w-full rounded-xl items-center justify-between"
                            : "flex text-[#AAB3CC] py-3 px-3 w-full rounded-xl items-center justify-between"
                        }
                      >
                        <div className="flex space-x-3">
                          <FaChartLine className="h-6"></FaChartLine>
                          <p className=" text-md relative">
                            Outreach{" "}
                          </p>
                        </div>
                        <img className="h-2" src={arrow}></img>
                      </div>
                    </Link>
                  )}

                  {internalSource && <Link to={REDIRECTION_LINKS.talentPool}>
                    <div
                      className={
                        window.location.href.includes(REDIRECTION_LINKS.talentPool)
                          ? "flex text-white bg-[#148EFF] py-3 px-3 w-full rounded-xl items-center justify-between"
                          : "flex text-[#AAB3CC] py-3 px-3 w-full rounded-xl items-center justify-between"
                      }
                    >
                      <div className="flex space-x-3">
                        {im5}
                        <p className="relative text-md">
                          Scout
                          <span className="absolute top-0 right-0 text-xs font-semibold bg-[#02101c] py-1 px-2 rounded-full">
                            Beta
                          </span>{" "}
                        </p>
                      </div>
                      <img className="h-2" src={arrow}></img>
                    </div>
                  </Link>}

                  <button
                    className=""
                    onClick={() => {
                      setVisible(false);
                    }}
                  >
                    <p className="text-white text-2xl font-light text-center">
                      X
                    </p>
                  </button>
                </div>
              </div>
            </div>
          )}

          <div
            className={!visible ? "w-full relative" : "w-full relative blur-lg"}
          >
            {openNotifications && (
              <div className="fixed right-0 space-y-4 p-4 bg-[#F1F4FB] h-screen overflow-y-auto z-50 shadow-lg w-1/3">
                {notifications
                  .sort((a, b) => {
                    const d1 = new Date(a.createdat);
                    const d2 = new Date(b.createdat);
                    return d2 - d1;
                  })
                  .map((n) => {
                    return (
                      <div className="flex space-x-3 items-start w-full border justify-start bg-white rounded-lg p-3">
                        <img src={rightarrow} className="h-16"></img>
                        <div>
                          <div className="flex justify-between w-full  items-start">
                            <p className="text-sm font-semibold">
                              {n.notificationtitle}
                            </p>
                            <div className="text-xs text-right">
                              <p>
                                {formatNotificationDate(
                                  n.createdat,
                                  notificationTimezone,
                                )}
                              </p>
                              <p>
                                {formatTime(n.createdat, notificationTimezone)}
                              </p>
                            </div>
                          </div>
                          <p className="text-xs mt-1 ">{n.message}</p>
                          <div className="mt-2">
                            {n.notificationtype != "" && (
                              <button
                                onClick={() => {
                                  handleNotificationClick(n);
                                }}
                                className="text-[#148EFF] text-base"
                              >
                                View
                              </button>
                            )}
                          </div>
                        </div>
                      </div>
                    );
                  })}
              </div>
            )}
            <div className=" flex md:hidden justify-between items-center px-5 bg-[#1D2A3D]">
              <img className="h-12 my-5  " src={logo} alt=""></img>
              <CiMenuFries
                className="text-white "
                onClick={() => {
                  setVisible(true);
                }}
              ></CiMenuFries>
            </div>
            {window.location.hash == "#/home" && <Dashboard />}

            {window.location.hash == "#/jobs" && <Jobs />}
            {window.location.hash == "#/settings/boards" && <Board />}
            {window.location.hash == "#/jobs/candidates" && <Candidate />}
            {window.location.hash == "#/jobs/candidates/temp" && (
              <TempCandidates />
            )}
            {window.location.hash == "#/jobs/candidates/new" && (
              <NewCandidate />
            )}
            {window.location.hash == "#/candidates/all" && <All></All>}
            {window.location.hash == "#/interviews" && <Interview></Interview>}
            {window.location.hash == "#/interviews/all" && <Intervieews />}
            {window.location.hash == "#/user" && <User />}
            {window.location.hash == "#/user/roles" && <Roles />}
            {window.location.hash == "#/help" && <Help />}
            {window.location.hash == "#/user/management" && <Management />}
            {window.location.hash == "#/settings" && <Templates />}
            {window.location.hash == "#/settings/profiles" && <Profile />}
            {
              window.location.hash.includes("#/jobs/candidates/about") && (
                <TestOfferInitiation></TestOfferInitiation>
              )
              // <AboutCandidate></AboutCandidate>
            }
            {window.location.hash == "#/jobs/new" && <NewJobs />}
            {window.location.hash == "#/user/new" && <NewUser />}
            {window.location.hash == "#/jobs/candidates/upload" && (
              <BulkUpload />
            )}

            {window.location.hash == "#/jobs/candidates/reqEmail" && (
              <DocumentReq />
            )}
            {window.location.hash == "#/jobs/candidates/proposal" && (
              <SalaryProposal></SalaryProposal>
            )}
            {window.location.hash == "#/jobs/hackerrankdata" && (
              <HackerRankCandidate></HackerRankCandidate>
            )}
            {window.location.hash == "#/jobs/coderbytedata" && (
              <CoderbyteCandidate></CoderbyteCandidate>
            )}
            {window.location.hash.includes(
              "#" + REDIRECTION_LINKS.interviewCredits,
            ) && <InterviewCredit />}
            {isHiringManager
              ? null
              : window.location.hash === "#" + REDIRECTION_LINKS.outreach && (
                <OutreachedJobs />
              )}
            {isHiringManager
              ? null
              : window.location.hash.includes(
                "#" + REDIRECTION_LINKS.outreachedJob,
              ) && <OutreachedCandidates />}
            {internalSource && window.location.hash.includes(
              "#" + REDIRECTION_LINKS.talentPool,
            ) && <TalentPool />}
          </div>
        </div>
      </div>
    </div>
  );
};

export default Home;

const NotificationIcon = () => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g id="Iconly/Light/Notification">
      <g id="Notification">
        <path
          id="Stroke 1"
          fillRule="evenodd"
          clipRule="evenodd"
          d="M12 17.8476C17.6392 17.8476 20.2481 17.1242 20.5 14.2205C20.5 11.3188 18.6812 11.5054 18.6812 7.94511C18.6812 5.16414 16.0452 2 12 2C7.95477 2 5.31885 5.16414 5.31885 7.94511C5.31885 11.5054 3.5 11.3188 3.5 14.2205C3.75295 17.1352 6.36177 17.8476 12 17.8476Z"
          stroke="#444D63"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          id="Stroke 3"
          d="M14.3888 20.8574C13.0247 22.3721 10.8967 22.3901 9.51947 20.8574"
          stroke="#444D63"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
    </g>
  </svg>
);

const NotificationIconWithBadge = ({ count }) => (
  <div className="relative inline-block">
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g id="Iconly/Light/Notification">
        <g id="Notification">
          <path
            id="Stroke 1"
            fillRule="evenodd"
            clipRule="evenodd"
            d="M12 17.8476C17.6392 17.8476 20.2481 17.1242 20.5 14.2205C20.5 11.3188 18.6812 11.5054 18.6812 7.94511C18.6812 5.16414 16.0452 2 12 2C7.95477 2 5.31885 5.16414 5.31885 7.94511C5.31885 11.5054 3.5 11.3188 3.5 14.2205C3.75295 17.1352 6.36177 17.8476 12 17.8476Z"
            stroke="#444D63"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            id="Stroke 3"
            d="M14.3888 20.8574C13.0247 22.3721 10.8967 22.3901 9.51947 20.8574"
            stroke="#444D63"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </g>
      </g>
    </svg>
    {count > 0 && (
      <span className="absolute top-[-7px] right-[-6px] bg-[#148EFF] text-white text-[8px] leading-[10px]  rounded-full px-[0.35rem] py-[3px]">
        {count}
      </span>
    )}
  </div>
);
